import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function Header() {
  return (
    <div
      style={{
        width: "100%",
        background: "linear-gradient(to right, #dce6f7, #e8f0ff)",
        padding: "12px 0",
        borderBottom: "3px solid #99b3e6",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
      }}
    >
      <Container fluid>
        <Row className="align-items-center text-center">
          <Col xs={2}>
            <img
              src="/favicon.ico"
              alt="Left Logo"
              style={{ width: "80px", height: "80px" }}
            />
          </Col>

          <Col xs={8}>
            <h4 className="fw-bold mb-1" style={{ color: "#003380" }}>
              ALL INDIA INSTITUTE OF MEDICAL SCIENCES NAGPUR
            </h4>

            <h6 style={{ fontWeight: 600, color: "#0047b3", lineHeight: "1.3" }}>
              Validating PIWIL mRNA and protein signatures as predictive markers
              <br />
              for fertilizing competence of sperm - A multicentric cohort study
            </h6>

            <h6 className="fw-bold" style={{ color: "#002b80" }}>
              Project ID: IIRPIG-2024-01-01230 (ICMR) <br></br> PI: Dr. T.S. Gugapriya<br></br>
              Co-PIs: Dr. Anjoo Agarwal, Dr. Bindu Bajaj, Dr. Navdeep Kaur Ghuman
            </h6>
          </Col>

          <Col xs={2}>
            <img
              src="/icmr_logo_verti.png"
              alt="Right Logo"
              style={{ width: "100px", height: "100px" }}
            />
          </Col>
        </Row>
      </Container >
    </div >
  );
}
